import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UserMenu from './UserMenu';
import MobileMenu from './MobileMenu';
import SettingsModal from './SettingsModal';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDatabase, FiLayers, FiHash, FiLogIn } = FiIcons;

const Header = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  useEffect(() => {
    const handleOpenMenu = () => setIsMobileMenuOpen(true);
    window.addEventListener('openMobileMenu', handleOpenMenu);
    return () => window.removeEventListener('openMobileMenu', handleOpenMenu);
  }, []);

  // Global settings modal listener - works on both desktop and mobile
  useEffect(() => {
    const handleOpenSettings = () => setIsSettingsOpen(true);
    window.addEventListener('openSettings', handleOpenSettings);
    return () => window.removeEventListener('openSettings', handleOpenSettings);
  }, []);

  return (
    <header className="bg-neo-yellow border-b-3 border-black sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2 text-xl font-bold text-black hover:scale-105 transition-transform">
            <div className="p-1 border-2 border-black bg-white shadow-neo-sm">
              <SafeIcon icon={FiDatabase} className="text-black" />
            </div>
            <span className="hidden sm:inline">Prompts DB</span>
          </Link>

          {user ? (
            <div className="flex items-center space-x-2 sm:space-x-4">
                <nav className="hidden md:flex items-center space-x-2 sm:space-x-4">
                    <Link
                    to="/"
                    className={`flex items-center space-x-1 px-3 sm:px-4 py-2 font-bold border-2 border-black transition-all text-sm sm:text-base ${
                        location.pathname === '/'
                        ? 'bg-black text-white shadow-none translate-x-[2px] translate-y-[2px]'
                        : 'bg-white text-black shadow-neo hover:-translate-y-1 hover:shadow-neo-lg'
                    }`}
                    >
                    <SafeIcon icon={FiDatabase} size={16} />
                    <span className="hidden md:inline">Library</span>
                    </Link>

                    <Link
                    to="/variables"
                    className={`flex items-center space-x-1 px-3 sm:px-4 py-2 font-bold border-2 border-black transition-all text-sm sm:text-base ${
                        location.pathname === '/variables'
                        ? 'bg-black text-white shadow-none translate-x-[2px] translate-y-[2px]'
                        : 'bg-white text-black shadow-neo hover:-translate-y-1 hover:shadow-neo-lg'
                    }`}
                    >
                    <SafeIcon icon={FiHash} size={16} />
                    <span className="hidden md:inline">Variables</span>
                    </Link>

                    <Link
                    to="/compose"
                    className={`flex items-center space-x-1 px-3 sm:px-4 py-2 font-bold border-2 border-black transition-all text-sm sm:text-base ${
                        location.pathname === '/compose'
                        ? 'bg-black text-white shadow-none translate-x-[2px] translate-y-[2px]'
                        : 'bg-white text-black shadow-neo hover:-translate-y-1 hover:shadow-neo-lg'
                    }`}
                    >
                    <SafeIcon icon={FiLayers} size={16} />
                    <span className="hidden md:inline">Compose</span>
                    </Link>
                </nav>
                <div className="h-8 w-px bg-black mx-2 hidden md:block"></div>
                <div className="hidden md:block">
                  <UserMenu />
                </div>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
                <Link to="/auth" className="neo-btn bg-white hover:bg-gray-50 flex items-center">
                    <SafeIcon icon={FiLogIn} className="mr-2" />
                    Sign In
                 </Link>
             </div>
           )}
         </div>
       </div>
       <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
       <SettingsModal isOpen={isSettingsOpen} onClose={() => setIsSettingsOpen(false)} />
    </header>
  );
};

export default Header;